import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Lenis from "lenis";
import { ArrowLeft, ShoppingBag, Crown, PackageSearch, User } from "lucide-react";
import { useCart } from "../../context/CartContext";
import FloatingBookButton from "../FloatingBookButton";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_loctician-hub/artifacts/fdlrkebv_WhatsApp%20Image%202025-11-21%20at%2012.44.06_ff66975e.jpg";

export const ShopLayout = ({ children, title }) => {
  const { count } = useCart();

  useEffect(() => {
    if (title) document.title = title;
    const lenis = new Lenis({ duration: 1.1 });
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); document.title = "Loctician Carlocs | Locs Specialist in Johannesburg"; };
  }, [title]);

  return (
    <div className="min-h-screen bg-[#1C1C1C] text-[#F5EFE3]" data-testid="shop-layout">
      <nav className="fixed top-0 w-full z-50 bg-[#1C1C1C]/85 backdrop-blur-xl border-b border-[#C9A24B]/15">
        <div className="max-w-7xl mx-auto px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-5">
            <Link to="/" className="flex items-center gap-2 text-[#F5EFE3]/60 hover:text-[#C9A24B] transition-colors text-xs uppercase tracking-widest" data-testid="shop-nav-home">
              <ArrowLeft className="w-4 h-4" /> <span className="hidden sm:inline">Home</span>
            </Link>
            <Link to="/shop" className="flex items-center gap-2" data-testid="shop-nav-logo">
              <img src={LOGO_URL} alt="Loctician Carlocs - Johannesburg loctician logo" className="h-10 w-auto" />
              <span className="hidden sm:flex items-center gap-1.5 text-[#C9A24B] text-xs uppercase tracking-[0.3em]">
                <Crown className="w-3.5 h-3.5" /> Shop
              </span>
            </Link>
          </div>
          <div className="flex items-center gap-2.5">
            <Link
              to="/track"
              data-testid="shop-nav-track"
              className="hidden sm:flex items-center gap-2 text-[#F5EFE3]/60 hover:text-[#C9A24B] text-xs uppercase tracking-widest transition-colors px-2"
              title="Track your order"
            >
              <PackageSearch className="w-4 h-4" /> Track
            </Link>
            <Link
              to="/account"
              data-testid="shop-nav-account"
              className="flex items-center gap-2 text-[#F5EFE3]/60 hover:text-[#C9A24B] text-xs uppercase tracking-widest transition-colors px-2"
              title="My account"
            >
              <User className="w-4 h-4" /> <span className="hidden sm:inline">Account</span>
            </Link>
            <Link
              to="/cart"
              data-testid="shop-nav-cart"
              className="relative flex items-center gap-2 border border-[#C9A24B]/40 text-[#C9A24B] px-4 py-2.5 rounded-full text-xs uppercase tracking-widest hover:bg-[#C9A24B] hover:text-[#1C1C1C] transition-all duration-300"
            >
              <ShoppingBag className="w-4 h-4" />
              <span className="hidden sm:inline">Cart</span>
              {count > 0 && (
                <span data-testid="cart-count-badge" className="absolute -top-2 -right-2 bg-[#C9A24B] text-[#1C1C1C] text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                  {count}
                </span>
              )}
            </Link>
          </div>
        </div>
      </nav>

      <main className="pt-20">{children}</main>

      <footer className="py-10 px-6 border-t border-[#C9A24B]/10 mt-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#F5EFE3]/30 text-xs">© {new Date().getFullYear()} Loctician Carlocs · Handmade in Johannesburg</p>
          <Link to="/" className="text-[#F5EFE3]/50 hover:text-[#C9A24B] text-xs transition-colors">Back to main site</Link>
        </div>
      </footer>
      <FloatingBookButton />
    </div>
  );
};
